
function wh_renderTruncatedText(fullText, fullHtml, containerId, characters) {

  const limit = characters;
  const container = document.getElementById(containerId);

  if (window.innerWidth > 900 || fullText.length <= limit) {
    container.innerHTML = fullHtml;
    return;
  }

  const truncated = fullText.slice(0, limit) + "... ";
  container.innerHTML = truncated + `<a href="#" id="toggle-link" style="color:black;">See more</a>`;

  document.getElementById("toggle-link").addEventListener("click", (e) => {
    e.preventDefault();
    container.innerHTML = fullHtml;
  });
}


